import { render, staticRenderFns } from "./PosPage.vue?vue&type=template&id=46672644&scoped=true"
import script from "./PosPage.vue?vue&type=script&lang=js"
export * from "./PosPage.vue?vue&type=script&lang=js"
import style0 from "./PosPage.vue?vue&type=style&index=0&id=46672644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46672644",
  null
  
)

export default component.exports